import React from "react";
// import ReactDom from 'react-dom';
import { getReactRender } from "./util";

const destroyFns: Function[] = [];
export function FnModalComponent(ReactComponent: React.FC<any>, config: any) {
  // const global = globalConfig();
  const root = document.getElementById("fotor-modal-root");
  if (!root) {
    const root = document.createElement("div");
    root.id = "fotor-modal-root";
    document.body.appendChild(root);
  }
  const container = document.createElement("div");
  let currentConfig = { ...config, close, open: true } as any;
  let timeoutId: ReturnType<typeof setTimeout>;

  let reactUnmount: any = () => {};

  function destroy(...args: any[]) {
    const triggerCancel = args.some((param) => param?.triggerCancel);
    if (triggerCancel) {
      config.onCancel?.(() => {}, ...args.slice(1));
    }
    for (let i = 0; i < destroyFns.length; i++) {
      const fn = destroyFns[i];
      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }

    reactUnmount();
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  }

  function render(props: any) {
    clearTimeout(timeoutId);

    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    timeoutId = setTimeout(() => {
      // const rootPrefixCls = global.getPrefixCls(undefined, getRootPrefixCls());
      // const iconPrefixCls = global.getIconPrefixCls();
      // const theme = global.getTheme();

      const dom = <ReactComponent {...props} />;

      const reactRender = getReactRender();

      reactUnmount = reactRender(
        // <ConfigProvider prefixCls={rootPrefixCls} iconPrefixCls={iconPrefixCls} theme={theme}>
        dom,
        // </ConfigProvider>,
        container
      );

      if (!container.parentNode) {
        if (root) {
          root.appendChild(container);
        }
      }
    });
  }

  function close(...args: any[]) {
    currentConfig = {
      ...currentConfig,
      open: false,
      afterClose: () => {
        if (typeof config.afterClose === "function") {
          config.afterClose();
        }
        // @ts-ignore
        destroy.apply(this, args);
      },
    };

    // Legacy support
    if (currentConfig.visible) {
      delete currentConfig.visible;
    }

    render(currentConfig);
  }

  function update(configUpdate: any) {
    if (typeof configUpdate === "function") {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = {
        ...currentConfig,
        ...configUpdate,
      };
    }
    render(currentConfig);
  }

  render(currentConfig);

  destroyFns.push(close);

  return {
    destroy: close,
    update,
  };
}

export default function WithFnModalComponent(
  ReactComponent: React.FC<any>,
  baseConfig?: any
) {
  const root = document.getElementById("fotor-modal-root");
  if (!root) {
    const root = document.createElement("div");
    root.id = "fotor-modal-root";
    document.body.appendChild(root);
  }
  return function (option: any) {
    return FnModalComponent(ReactComponent, { ...baseConfig, ...option });
  };
}
